import { createTheme, type ThemeOptions } from "@mui/material/styles";

export type Mode = 'light' | 'dark';

export const createAppTheme = (mode: Mode) => {
  const base: ThemeOptions = {
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            background: { default: '#F8FAFC', paper: '#FFFFFF' },
            // Align with Tailwind `brand` color scale (brand-500)
            primary: { main: '#055590' },
            secondary: { main: '#10B981' },
          }
        : {
            background: { default: '#0F172A', paper: '#0B1220' },
            // Slightly lighter primary for dark mode (brand-400)
            primary: { main: '#1A8CFF' },
            secondary: { main: '#34D399' },
          }),
    },
    typography: {
      fontFamily: 'Outfit, sans-serif',
      fontSize: 16, // Base font size ~16px for better legibility
      h1: { fontSize: '2.125rem', fontWeight: 700 }, // ~34px
      h2: { fontSize: '1.875rem', fontWeight: 700 }, // ~30px
      h3: { fontSize: '1.625rem', fontWeight: 700 }, // ~26px
      h4: { fontSize: '1.375rem', fontWeight: 600 }, // ~22px
      h5: { fontSize: '1.25rem', fontWeight: 600 }, // ~20px
      h6: { fontSize: '1.125rem', fontWeight: 600 }, // ~18px
      body1: { fontSize: '1rem', lineHeight: 1.65 }, // 16px
      body2: { fontSize: '0.9375rem', lineHeight: 1.6 }, // 15px
      button: { textTransform: 'none', fontWeight: 600 },
      subtitle1: { fontSize: '1rem', fontWeight: 500 },
      subtitle2: { fontSize: '0.95rem', fontWeight: 500 },
      caption: { fontSize: '0.85rem' },
      overline: { fontSize: '0.8rem', letterSpacing: '0.06em' },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { minHeight: '100vh', margin: 0 },
        },
      },
    },
  };

  return createTheme(base);
};
